export const userNameInitials = (userName: string, delimiter = ' ') => {
  if (!userName) {
    return ''
  }

  // eslint-disable-next-line prefer-const
  let [surname, firstname, patronymic] = userName.split(delimiter)
  if (surname) surname = surname[0].toUpperCase() + surname.slice(1)
  if (firstname) firstname = `${firstname.substring(0, 1).toUpperCase()}.`
  if (patronymic) patronymic = `${patronymic.substring(0, 1).toUpperCase()}.`
  return [surname, firstname, patronymic].filter(Boolean).join(' ')
}
